import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';

// ============================================================================
// PAYLOAD MAPPING
// ============================================================================

import type { ParsedValues } from './validation';

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.length,
    W: input.tributaryWidth,
    wadd: input.addedWeight,
    supports: input.supports,
    orientation: input.orientation,
    sectionType: input.sectionType,
    b: input.b,
    h: input.h,
    dia: input.dia,
    tf: input.tf,
    tw: input.tw,
    rebar: input.rebar,
    rebarDepth: input.rebarDepth,
    cover: input.cover,
    shearRebar: input.shearRebar,
    fy: input.fy,
    fc: input.fc,
    dif: input.dif,
    axialLoad: input.axialLoad,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable: analyzeConcreteElementCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>('/iConcreteElement/', mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeConcreteElementCancellable };
